function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
export default (function (_ref) {
  var _Container;
  var mobileFirstMediaQueries = _ref.mobileFirstMediaQueries,
    containers = _ref.containers,
    sizes = _ref.sizes;
  return {
    Container: (_Container = {
      width: '100%',
      margin: 'auto',
      paddingLeft: sizes.gutterWidth,
      paddingRight: sizes.gutterWidth
    }, _defineProperty(_Container, mobileFirstMediaQueries.tablet, {
      maxWidth: containers.tablet
    }), _defineProperty(_Container, mobileFirstMediaQueries.laptop, {
      maxWidth: containers.laptop
    }), _defineProperty(_Container, mobileFirstMediaQueries.desktop, {
      maxWidth: containers.desktop
    }), _Container)
  };
});